var manifest = [{
  stem: "activity",
  icon: "Activity"
}, {
  stem: "add-and-subtract",
  icon: "AddAndSubtract"
}, {
  stem: "add-circle",
  icon: "AddCircle"
}, {
  stem: "add-rectangle",
  icon: "AddRectangle"
}, {
  stem: "add",
  icon: "Add"
}, {
  stem: "address-book",
  icon: "AddressBook"
}, {
  stem: "adjustment",
  icon: "Adjustment"
}, {
  stem: "airplay-wave",
  icon: "AirplayWave"
}, {
  stem: "alarm-add",
  icon: "AlarmAdd"
}, {
  stem: "alarm-off",
  icon: "AlarmOff"
}, {
  stem: "alarm",
  icon: "Alarm"
}, {
  stem: "align-top",
  icon: "AlignTop"
}, {
  stem: "align-vertical",
  icon: "AlignVertical"
}, {
  stem: "alpha",
  icon: "Alpha"
}, {
  stem: "analytics",
  icon: "Analytics"
}, {
  stem: "anchor",
  icon: "Anchor"
}, {
  stem: "angry",
  icon: "Angry"
}, {
  stem: "animation-1",
  icon: "Animation1"
}, {
  stem: "animation",
  icon: "Animation"
}, {
  stem: "anticlockwise",
  icon: "Anticlockwise"
}, {
  stem: "api",
  icon: "Api"
}, {
  stem: "app",
  icon: "App"
}, {
  stem: "apple",
  icon: "Apple"
}, {
  stem: "application",
  icon: "Application"
}, {
  stem: "architecture-hui-style",
  icon: "ArchitectureHuiStyle"
}, {
  stem: "archway-1",
  icon: "Archway1"
}, {
  stem: "archway",
  icon: "Archway"
}, {
  stem: "arrow-down-circle",
  icon: "ArrowDownCircle"
}, {
  stem: "arrow-down-rectangle",
  icon: "ArrowDownRectangle"
}, {
  stem: "arrow-down",
  icon: "ArrowDown"
}, {
  stem: "arrow-left-circle",
  icon: "ArrowLeftCircle"
}, {
  stem: "arrow-left-down-circle",
  icon: "ArrowLeftDownCircle"
}, {
  stem: "arrow-left-down",
  icon: "ArrowLeftDown"
}, {
  stem: "arrow-left-right-1",
  icon: "ArrowLeftRight1"
}, {
  stem: "arrow-left-right-2",
  icon: "ArrowLeftRight2"
}, {
  stem: "arrow-left-right-3",
  icon: "ArrowLeftRight3"
}, {
  stem: "arrow-left-right-circle",
  icon: "ArrowLeftRightCircle"
}, {
  stem: "arrow-left-up-circle",
  icon: "ArrowLeftUpCircle"
}, {
  stem: "arrow-left-up",
  icon: "ArrowLeftUp"
}, {
  stem: "arrow-left",
  icon: "ArrowLeft"
}, {
  stem: "arrow-right-circle",
  icon: "ArrowRightCircle"
}, {
  stem: "arrow-right-down-circle",
  icon: "ArrowRightDownCircle"
}, {
  stem: "arrow-right-down",
  icon: "ArrowRightDown"
}, {
  stem: "arrow-right-up-circle",
  icon: "ArrowRightUpCircle"
}, {
  stem: "arrow-right-up",
  icon: "ArrowRightUp"
}, {
  stem: "arrow-right",
  icon: "ArrowRight"
}, {
  stem: "arrow-triangle-down-filled",
  icon: "ArrowTriangleDownFilled"
}, {
  stem: "arrow-triangle-down",
  icon: "ArrowTriangleDown"
}, {
  stem: "arrow-triangle-up-filled",
  icon: "ArrowTriangleUpFilled"
}, {
  stem: "arrow-triangle-up",
  icon: "ArrowTriangleUp"
}, {
  stem: "arrow-up-circle",
  icon: "ArrowUpCircle"
}, {
  stem: "arrow-up-down-1",
  icon: "ArrowUpDown1"
}, {
  stem: "arrow-up-down-2",
  icon: "ArrowUpDown2"
}, {
  stem: "arrow-up-down-3",
  icon: "ArrowUpDown3"
}, {
  stem: "arrow-up-down-circle",
  icon: "ArrowUpDownCircle"
}, {
  stem: "arrow-up",
  icon: "ArrowUp"
}, {
  stem: "artboard",
  icon: "Artboard"
}, {
  stem: "article",
  icon: "Article"
}, {
  stem: "assignment-checked",
  icon: "AssignmentChecked"
}, {
  stem: "assignment-code",
  icon: "AssignmentCode"
}, {
  stem: "assignment-error",
  icon: "AssignmentError"
}, {
  stem: "assignment-user",
  icon: "AssignmentUser"
}, {
  stem: "assignment",
  icon: "Assignment"
}, {
  stem: "attach",
  icon: "Attach"
}, {
  stem: "attic-1",
  icon: "Attic1"
}, {
  stem: "attic",
  icon: "Attic"
}, {
  stem: "audio",
  icon: "Audio"
}, {
  stem: "awkward",
  icon: "Awkward"
}, {
  stem: "backtop-rectangle",
  icon: "BacktopRectangle"
}, {
  stem: "backtop",
  icon: "Backtop"
}, {
  stem: "backup",
  icon: "Backup"
}, {
  stem: "backward",
  icon: "Backward"
}, {
  stem: "bad-laugh",
  icon: "BadLaugh"
}, {
  stem: "bamboo-shoot",
  icon: "BambooShoot"
}, {
  stem: "banana",
  icon: "Banana"
}, {
  stem: "barbecue",
  icon: "Barbecue"
}, {
  stem: "barcode-1",
  icon: "Barcode1"
}, {
  stem: "barcode",
  icon: "Barcode"
}, {
  stem: "base-station",
  icon: "BaseStation"
}, {
  stem: "battery-add",
  icon: "BatteryAdd"
}, {
  stem: "battery-charging",
  icon: "BatteryCharging"
}, {
  stem: "battery-low",
  icon: "BatteryLow"
}, {
  stem: "battery",
  icon: "Battery"
}, {
  stem: "bean",
  icon: "Bean"
}, {
  stem: "beer",
  icon: "Beer"
}, {
  stem: "beta",
  icon: "Beta"
}, {
  stem: "bifurcate",
  icon: "Bifurcate"
}, {
  stem: "bill",
  icon: "Bill"
}, {
  stem: "blockchain",
  icon: "Blockchain"
}, {
  stem: "bluetooth",
  icon: "Bluetooth"
}, {
  stem: "bone",
  icon: "Bone"
}, {
  stem: "book-open",
  icon: "BookOpen"
}, {
  stem: "book",
  icon: "Book"
}, {
  stem: "bookmark-add",
  icon: "BookmarkAdd"
}, {
  stem: "bookmark-checked",
  icon: "BookmarkChecked"
}, {
  stem: "bookmark-double",
  icon: "BookmarkDouble"
}, {
  stem: "bookmark-minus",
  icon: "BookmarkMinus"
}, {
  stem: "bookmark",
  icon: "Bookmark"
}, {
  stem: "braces",
  icon: "Braces"
}, {
  stem: "brackets",
  icon: "Brackets"
}, {
  stem: "bread",
  icon: "Bread"
}, {
  stem: "bridge-1",
  icon: "Bridge1"
}, {
  stem: "bridge-2",
  icon: "Bridge2"
}, {
  stem: "bridge-3",
  icon: "Bridge3"
}, {
  stem: "bridge-4",
  icon: "Bridge4"
}, {
  stem: "bridge-5",
  icon: "Bridge5"
}, {
  stem: "bridge-6",
  icon: "Bridge6"
}, {
  stem: "bridge",
  icon: "Bridge"
}, {
  stem: "brightness-1",
  icon: "Brightness1"
}, {
  stem: "brightness",
  icon: "Brightness"
}, {
  stem: "broccoli",
  icon: "Broccoli"
}, {
  stem: "browse-gallery",
  icon: "BrowseGallery"
}, {
  stem: "browse-off",
  icon: "BrowseOff"
}, {
  stem: "browse",
  icon: "Browse"
}, {
  stem: "brush",
  icon: "Brush"
}, {
  stem: "bug-report",
  icon: "BugReport"
}, {
  stem: "bug",
  icon: "Bug"
}, {
  stem: "building-1",
  icon: "Building1"
}, {
  stem: "building-2",
  icon: "Building2"
}, {
  stem: "building-3",
  icon: "Building3"
}, {
  stem: "building-4",
  icon: "Building4"
}, {
  stem: "building-5",
  icon: "Building5"
}, {
  stem: "building",
  icon: "Building"
}, {
  stem: "bulletpoint",
  icon: "Bulletpoint"
}, {
  stem: "button",
  icon: "Button"
}, {
  stem: "cabbage",
  icon: "Cabbage"
}, {
  stem: "cake",
  icon: "Cake"
}, {
  stem: "calculation-1",
  icon: "Calculation1"
}, {
  stem: "calculation",
  icon: "Calculation"
}, {
  stem: "calculator-1",
  icon: "Calculator1"
}, {
  stem: "calculator",
  icon: "Calculator"
}, {
  stem: "calendar-1",
  icon: "Calendar1"
}, {
  stem: "calendar-2",
  icon: "Calendar2"
}, {
  stem: "calendar-edit",
  icon: "CalendarEdit"
}, {
  stem: "calendar-event",
  icon: "CalendarEvent"
}, {
  stem: "calendar",
  icon: "Calendar"
}, {
  stem: "call-1",
  icon: "Call1"
}, {
  stem: "call-cancel",
  icon: "CallCancel"
}, {
  stem: "call-forwarded",
  icon: "CallForwarded"
}, {
  stem: "call-incoming",
  icon: "CallIncoming"
}, {
  stem: "call-off",
  icon: "CallOff"
}, {
  stem: "call",
  icon: "Call"
}, {
  stem: "calm-1",
  icon: "Calm1"
}, {
  stem: "calm",
  icon: "Calm"
}, {
  stem: "camera-1",
  icon: "Camera1"
}, {
  stem: "camera-2",
  icon: "Camera2"
}, {
  stem: "camera-off",
  icon: "CameraOff"
}, {
  stem: "camera",
  icon: "Camera"
}, {
  stem: "candy",
  icon: "Candy"
}, {
  stem: "card",
  icon: "Card"
}, {
  stem: "cardmembership",
  icon: "Cardmembership"
}, {
  stem: "caret-down-small",
  icon: "CaretDownSmall"
}, {
  stem: "caret-down",
  icon: "CaretDown"
}, {
  stem: "caret-left-small",
  icon: "CaretLeftSmall"
}, {
  stem: "caret-left",
  icon: "CaretLeft"
}, {
  stem: "caret-right-small",
  icon: "CaretRightSmall"
}, {
  stem: "caret-right",
  icon: "CaretRight"
}, {
  stem: "caret-up-small",
  icon: "CaretUpSmall"
}, {
  stem: "caret-up",
  icon: "CaretUp"
}, {
  stem: "cart-add",
  icon: "CartAdd"
}, {
  stem: "cart",
  icon: "Cart"
}, {
  stem: "cast",
  icon: "Cast"
}, {
  stem: "castle-1",
  icon: "Castle1"
}, {
  stem: "castle-2",
  icon: "Castle2"
}, {
  stem: "castle-3",
  icon: "Castle3"
}, {
  stem: "castle-4",
  icon: "Castle4"
}, {
  stem: "castle-5",
  icon: "Castle5"
}, {
  stem: "castle-6",
  icon: "Castle6"
}, {
  stem: "castle-7",
  icon: "Castle7"
}, {
  stem: "castle",
  icon: "Castle"
}, {
  stem: "cat",
  icon: "Cat"
}, {
  stem: "catalog",
  icon: "Catalog"
}, {
  stem: "cd",
  icon: "Cd"
}, {
  stem: "celsius",
  icon: "Celsius"
}, {
  stem: "center-focus-strong",
  icon: "CenterFocusStrong"
}, {
  stem: "centimeter",
  icon: "Centimeter"
}, {
  stem: "certificate-1",
  icon: "Certificate1"
}, {
  stem: "certificate",
  icon: "Certificate"
}, {
  stem: "chart-3d",
  icon: "Chart3D"
}, {
  stem: "chart-add",
  icon: "ChartAdd"
}, {
  stem: "chart-analytics",
  icon: "ChartAnalytics"
}, {
  stem: "chart-area-multi",
  icon: "ChartAreaMulti"
}, {
  stem: "chart-area",
  icon: "ChartArea"
}, {
  stem: "chart-bar",
  icon: "ChartBar"
}, {
  stem: "chart-bubble",
  icon: "ChartBubble"
}, {
  stem: "chart-colum",
  icon: "ChartColum"
}, {
  stem: "chart-combo",
  icon: "ChartCombo"
}, {
  stem: "chart-line-data-1",
  icon: "ChartLineData1"
}, {
  stem: "chart-line-data",
  icon: "ChartLineData"
}, {
  stem: "chart-line-multi",
  icon: "ChartLineMulti"
}, {
  stem: "chart-line",
  icon: "ChartLine"
}, {
  stem: "chart-maximum",
  icon: "ChartMaximum"
}, {
  stem: "chart-median",
  icon: "ChartMedian"
}, {
  stem: "chart-minimum",
  icon: "ChartMinimum"
}, {
  stem: "chart-pie",
  icon: "ChartPie"
}, {
  stem: "chart-radar",
  icon: "ChartRadar"
}, {
  stem: "chart-radial",
  icon: "ChartRadial"
}, {
  stem: "chart-ring-1",
  icon: "ChartRing1"
}, {
  stem: "chart-ring",
  icon: "ChartRing"
}, {
  stem: "chart-scatter",
  icon: "ChartScatter"
}, {
  stem: "chart-stacked",
  icon: "ChartStacked"
}, {
  stem: "chart",
  icon: "Chart"
}, {
  stem: "chat-add",
  icon: "ChatAdd"
}, {
  stem: "chat-bubble-1",
  icon: "ChatBubble1"
}, {
  stem: "chat-bubble-add",
  icon: "ChatBubbleAdd"
}, {
  stem: "chat-bubble-error",
  icon: "ChatBubbleError"
}, {
  stem: "chat-bubble-help",
  icon: "ChatBubbleHelp"
}, {
  stem: "chat-bubble-history",
  icon: "ChatBubbleHistory"
}, {
  stem: "chat-bubble-locked",
  icon: "ChatBubbleLocked"
}, {
  stem: "chat-bubble-smile",
  icon: "ChatBubbleSmile"
}, {
  stem: "chat-bubble",
  icon: "ChatBubble"
}, {
  stem: "chat-checked",
  icon: "ChatChecked"
}, {
  stem: "chat-clear",
  icon: "ChatClear"
}, {
  stem: "chat-double",
  icon: "ChatDouble"
}, {
  stem: "chat-error",
  icon: "ChatError"
}, {
  stem: "chat-heart",
  icon: "ChatHeart"
}, {
  stem: "chat-message",
  icon: "ChatMessage"
}, {
  stem: "chat-off",
  icon: "ChatOff"
}, {
  stem: "chat-poll",
  icon: "ChatPoll"
}, {
  stem: "chat-setting",
  icon: "ChatSetting"
}, {
  stem: "chat",
  icon: "Chat"
}, {
  stem: "check-circle-filled",
  icon: "CheckCircleFilled"
}, {
  stem: "check-circle",
  icon: "CheckCircle"
}, {
  stem: "check-double",
  icon: "CheckDouble"
}, {
  stem: "check-rectangle-filled",
  icon: "CheckRectangleFilled"
}, {
  stem: "check-rectangle",
  icon: "CheckRectangle"
}, {
  stem: "check",
  icon: "Check"
}, {
  stem: "cheese",
  icon: "Cheese"
}, {
  stem: "cherry",
  icon: "Cherry"
}, {
  stem: "chevron-down-circle",
  icon: "ChevronDownCircle"
}, {
  stem: "chevron-down-double-s",
  icon: "ChevronDownDoubleS"
}, {
  stem: "chevron-down-double",
  icon: "ChevronDownDouble"
}, {
  stem: "chevron-down-rectangle",
  icon: "ChevronDownRectangle"
}, {
  stem: "chevron-down-s",
  icon: "ChevronDownS"
}, {
  stem: "chevron-down",
  icon: "ChevronDown"
}, {
  stem: "chevron-left-circle",
  icon: "ChevronLeftCircle"
}, {
  stem: "chevron-left-double-s",
  icon: "ChevronLeftDoubleS"
}, {
  stem: "chevron-left-double",
  icon: "ChevronLeftDouble"
}, {
  stem: "chevron-left-rectangle",
  icon: "ChevronLeftRectangle"
}, {
  stem: "chevron-left-s",
  icon: "ChevronLeftS"
}, {
  stem: "chevron-left",
  icon: "ChevronLeft"
}, {
  stem: "chevron-right-circle",
  icon: "ChevronRightCircle"
}, {
  stem: "chevron-right-double-s",
  icon: "ChevronRightDoubleS"
}, {
  stem: "chevron-right-double",
  icon: "ChevronRightDouble"
}, {
  stem: "chevron-right-rectangle",
  icon: "ChevronRightRectangle"
}, {
  stem: "chevron-right-s",
  icon: "ChevronRightS"
}, {
  stem: "chevron-right",
  icon: "ChevronRight"
}, {
  stem: "chevron-up-circle",
  icon: "ChevronUpCircle"
}, {
  stem: "chevron-up-double-s",
  icon: "ChevronUpDoubleS"
}, {
  stem: "chevron-up-double",
  icon: "ChevronUpDouble"
}, {
  stem: "chevron-up-rectangle",
  icon: "ChevronUpRectangle"
}, {
  stem: "chevron-up-s",
  icon: "ChevronUpS"
}, {
  stem: "chevron-up",
  icon: "ChevronUp"
}, {
  stem: "chicken",
  icon: "Chicken"
}, {
  stem: "chili",
  icon: "Chili"
}, {
  stem: "chimney-1",
  icon: "Chimney1"
}, {
  stem: "chimney-2",
  icon: "Chimney2"
}, {
  stem: "chimney",
  icon: "Chimney"
}, {
  stem: "chinese-cabbage",
  icon: "ChineseCabbage"
}, {
  stem: "church",
  icon: "Church"
}, {
  stem: "circle",
  icon: "Circle"
}, {
  stem: "city-1",
  icon: "City1"
}, {
  stem: "city-10",
  icon: "City10"
}, {
  stem: "city-11",
  icon: "City11"
}, {
  stem: "city-12",
  icon: "City12"
}, {
  stem: "city-13",
  icon: "City13"
}, {
  stem: "city-14",
  icon: "City14"
}, {
  stem: "city-15",
  icon: "City15"
}, {
  stem: "city-2",
  icon: "City2"
}, {
  stem: "city-3",
  icon: "City3"
}, {
  stem: "city-4",
  icon: "City4"
}, {
  stem: "city-5",
  icon: "City5"
}, {
  stem: "city-6",
  icon: "City6"
}, {
  stem: "city-7",
  icon: "City7"
}, {
  stem: "city-8",
  icon: "City8"
}, {
  stem: "city-9",
  icon: "City9"
}, {
  stem: "city-ancient-1",
  icon: "CityAncient1"
}, {
  stem: "city-ancient-2",
  icon: "CityAncient2"
}, {
  stem: "city-ancient",
  icon: "CityAncient"
}, {
  stem: "city",
  icon: "City"
}, {
  stem: "clear-formatting-1",
  icon: "ClearFormatting1"
}, {
  stem: "clear-formatting",
  icon: "ClearFormatting"
}, {
  stem: "clear",
  icon: "Clear"
}, {
  stem: "close-circle-filled",
  icon: "CloseCircleFilled"
}, {
  stem: "close-circle",
  icon: "CloseCircle"
}, {
  stem: "close-octagon",
  icon: "CloseOctagon"
}, {
  stem: "close-rectangle",
  icon: "CloseRectangle"
}, {
  stem: "close",
  icon: "Close"
}, {
  stem: "cloud-download",
  icon: "CloudDownload"
}, {
  stem: "cloud-upload",
  icon: "CloudUpload"
}, {
  stem: "cloud",
  icon: "Cloud"
}, {
  stem: "cloudy-day",
  icon: "CloudyDay"
}, {
  stem: "cloudy-night-rain",
  icon: "CloudyNightRain"
}, {
  stem: "cloudy-night",
  icon: "CloudyNight"
}, {
  stem: "cloudy-rain",
  icon: "CloudyRain"
}, {
  stem: "cloudy-sunny",
  icon: "CloudySunny"
}, {
  stem: "code-1",
  icon: "Code1"
}, {
  stem: "code-off",
  icon: "CodeOff"
}, {
  stem: "code",
  icon: "Code"
}, {
  stem: "cola",
  icon: "Cola"
}, {
  stem: "collage",
  icon: "Collage"
}, {
  stem: "collection",
  icon: "Collection"
}, {
  stem: "color-invert",
  icon: "ColorInvert"
}, {
  stem: "combination",
  icon: "Combination"
}, {
  stem: "command",
  icon: "Command"
}, {
  stem: "compass-1",
  icon: "Compass1"
}, {
  stem: "compass",
  icon: "Compass"
}, {
  stem: "component-breadcrumb",
  icon: "ComponentBreadcrumb"
}, {
  stem: "component-checkbox",
  icon: "ComponentCheckbox"
}, {
  stem: "component-divider-horizontal",
  icon: "ComponentDividerHorizontal"
}, {
  stem: "component-divider-vertical",
  icon: "ComponentDividerVertical"
}, {
  stem: "component-dropdown",
  icon: "ComponentDropdown"
}, {
  stem: "component-grid",
  icon: "ComponentGrid"
}, {
  stem: "component-input",
  icon: "ComponentInput"
}, {
  stem: "component-layout",
  icon: "ComponentLayout"
}, {
  stem: "component-radio",
  icon: "ComponentRadio"
}, {
  stem: "component-space",
  icon: "ComponentSpace"
}, {
  stem: "component-steps",
  icon: "ComponentSteps"
}, {
  stem: "component-switch",
  icon: "ComponentSwitch"
}, {
  stem: "constraint",
  icon: "Constraint"
}, {
  stem: "contrast-1",
  icon: "Contrast1"
}, {
  stem: "contrast",
  icon: "Contrast"
}, {
  stem: "control-platform",
  icon: "ControlPlatform"
}, {
  stem: "cooperate",
  icon: "Cooperate"
}, {
  stem: "coordinate-system",
  icon: "CoordinateSystem"
}, {
  stem: "copy",
  icon: "Copy"
}, {
  stem: "copyright",
  icon: "Copyright"
}, {
  stem: "corn",
  icon: "Corn"
}, {
  stem: "coupon",
  icon: "Coupon"
}, {
  stem: "course",
  icon: "Course"
}, {
  stem: "cpu",
  icon: "Cpu"
}, {
  stem: "crack",
  icon: "Crack"
}, {
  stem: "creditcard-add",
  icon: "CreditcardAdd"
}, {
  stem: "creditcard-off",
  icon: "CreditcardOff"
}, {
  stem: "creditcard",
  icon: "Creditcard"
}, {
  stem: "crooked-smile",
  icon: "CrookedSmile"
}, {
  stem: "cry-and-laugh",
  icon: "CryAndLaugh"
}, {
  stem: "cry-loudly",
  icon: "CryLoudly"
}, {
  stem: "css3",
  icon: "Css3"
}, {
  stem: "cucumber",
  icon: "Cucumber"
}, {
  stem: "currency-exchange",
  icon: "CurrencyExchange"
}, {
  stem: "cursor",
  icon: "Cursor"
}, {
  stem: "curtain",
  icon: "Curtain"
}, {
  stem: "curve",
  icon: "Curve"
}, {
  stem: "cut-1",
  icon: "Cut1"
}, {
  stem: "cut",
  icon: "Cut"
}, {
  stem: "dam-1",
  icon: "Dam1"
}, {
  stem: "dam-2",
  icon: "Dam2"
}, {
  stem: "dam-3",
  icon: "Dam3"
}, {
  stem: "dam-4",
  icon: "Dam4"
}, {
  stem: "dam-5",
  icon: "Dam5"
}, {
  stem: "dam-6",
  icon: "Dam6"
}, {
  stem: "dam-7",
  icon: "Dam7"
}, {
  stem: "dam",
  icon: "Dam"
}, {
  stem: "dart-board",
  icon: "DartBoard"
}, {
  stem: "dashboard-1",
  icon: "Dashboard1"
}, {
  stem: "dashboard",
  icon: "Dashboard"
}, {
  stem: "data-base",
  icon: "DataBase"
}, {
  stem: "data-checked",
  icon: "DataChecked"
}, {
  stem: "data-display",
  icon: "DataDisplay"
}, {
  stem: "data-error",
  icon: "DataError"
}, {
  stem: "data-search",
  icon: "DataSearch"
}, {
  stem: "data",
  icon: "Data"
}, {
  stem: "delete-1",
  icon: "Delete1"
}, {
  stem: "delete-time",
  icon: "DeleteTime"
}, {
  stem: "delete",
  icon: "Delete"
}, {
  stem: "delta",
  icon: "Delta"
}, {
  stem: "depressed",
  icon: "Depressed"
}, {
  stem: "desktop-1",
  icon: "Desktop1"
}, {
  stem: "desktop",
  icon: "Desktop"
}, {
  stem: "despise",
  icon: "Despise"
}, {
  stem: "device",
  icon: "Device"
}, {
  stem: "discount-filled",
  icon: "DiscountFilled"
}, {
  stem: "discount",
  icon: "Discount"
}, {
  stem: "dissatisfaction",
  icon: "Dissatisfaction"
}, {
  stem: "divide",
  icon: "Divide"
}, {
  stem: "dividers-1",
  icon: "Dividers1"
}, {
  stem: "dividers",
  icon: "Dividers"
}, {
  stem: "doge",
  icon: "Doge"
}, {
  stem: "double-storey",
  icon: "DoubleStorey"
}, {
  stem: "download-1",
  icon: "Download1"
}, {
  stem: "download",
  icon: "Download"
}, {
  stem: "downscale",
  icon: "Downscale"
}, {
  stem: "drag-drop",
  icon: "DragDrop"
}, {
  stem: "drag-move",
  icon: "DragMove"
}, {
  stem: "drink",
  icon: "Drink"
}, {
  stem: "drumstick",
  icon: "Drumstick"
}, {
  stem: "dv",
  icon: "Dv"
}, {
  stem: "dvd",
  icon: "Dvd"
}, {
  stem: "earphone",
  icon: "Earphone"
}, {
  stem: "earth",
  icon: "Earth"
}, {
  stem: "edit-1",
  icon: "Edit1"
}, {
  stem: "edit-2",
  icon: "Edit2"
}, {
  stem: "edit-off",
  icon: "EditOff"
}, {
  stem: "edit",
  icon: "Edit"
}, {
  stem: "education",
  icon: "Education"
}, {
  stem: "eggplant",
  icon: "Eggplant"
}, {
  stem: "ellipsis",
  icon: "Ellipsis"
}, {
  stem: "emo-emotional",
  icon: "EmoEmotional"
}, {
  stem: "enter",
  icon: "Enter"
}, {
  stem: "equal",
  icon: "Equal"
}, {
  stem: "error-circle-filled",
  icon: "ErrorCircleFilled"
}, {
  stem: "error-circle",
  icon: "ErrorCircle"
}, {
  stem: "error-triangle",
  icon: "ErrorTriangle"
}, {
  stem: "error",
  icon: "Error"
}, {
  stem: "excited-1",
  icon: "Excited1"
}, {
  stem: "excited",
  icon: "Excited"
}, {
  stem: "expand-horizontal",
  icon: "ExpandHorizontal"
}, {
  stem: "expand-vertical",
  icon: "ExpandVertical"
}, {
  stem: "explore-off",
  icon: "ExploreOff"
}, {
  stem: "explore",
  icon: "Explore"
}, {
  stem: "exposure",
  icon: "Exposure"
}, {
  stem: "extension-off",
  icon: "ExtensionOff"
}, {
  stem: "extension",
  icon: "Extension"
}, {
  stem: "face-retouching",
  icon: "FaceRetouching"
}, {
  stem: "fact-check",
  icon: "FactCheck"
}, {
  stem: "fahrenheit-scale",
  icon: "FahrenheitScale"
}, {
  stem: "feel-at-ease",
  icon: "FeelAtEase"
}, {
  stem: "ferocious",
  icon: "Ferocious"
}, {
  stem: "ferris-wheel",
  icon: "FerrisWheel"
}, {
  stem: "file-1",
  icon: "File1"
}, {
  stem: "file-add-1",
  icon: "FileAdd1"
}, {
  stem: "file-add",
  icon: "FileAdd"
}, {
  stem: "file-attachment",
  icon: "FileAttachment"
}, {
  stem: "file-blocked",
  icon: "FileBlocked"
}, {
  stem: "file-code-1",
  icon: "FileCode1"
}, {
  stem: "file-code",
  icon: "FileCode"
}, {
  stem: "file-copy",
  icon: "FileCopy"
}, {
  stem: "file-download",
  icon: "FileDownload"
}, {
  stem: "file-excel",
  icon: "FileExcel"
}, {
  stem: "file-export",
  icon: "FileExport"
}, {
  stem: "file-icon",
  icon: "FileIcon"
}, {
  stem: "file-image",
  icon: "FileImage"
}, {
  stem: "file-import",
  icon: "FileImport"
}, {
  stem: "file-locked",
  icon: "FileLocked"
}, {
  stem: "file-minus",
  icon: "FileMinus"
}, {
  stem: "file-music",
  icon: "FileMusic"
}, {
  stem: "file-onenote",
  icon: "FileOnenote"
}, {
  stem: "file-outlook",
  icon: "FileOutlook"
}, {
  stem: "file-paste",
  icon: "FilePaste"
}, {
  stem: "file-pdf",
  icon: "FilePdf"
}, {
  stem: "file-powerpoint",
  icon: "FilePowerpoint"
}, {
  stem: "file-restore",
  icon: "FileRestore"
}, {
  stem: "file-safety",
  icon: "FileSafety"
}, {
  stem: "file-search",
  icon: "FileSearch"
}, {
  stem: "file-setting",
  icon: "FileSetting"
}, {
  stem: "file-teams",
  icon: "FileTeams"
}, {
  stem: "file-unknown",
  icon: "FileUnknown"
}, {
  stem: "file-unlocked",
  icon: "FileUnlocked"
}, {
  stem: "file-word",
  icon: "FileWord"
}, {
  stem: "file-zip",
  icon: "FileZip"
}, {
  stem: "file",
  icon: "File"
}, {
  stem: "fill-color-1",
  icon: "FillColor1"
}, {
  stem: "fill-color",
  icon: "FillColor"
}, {
  stem: "film-1",
  icon: "Film1"
}, {
  stem: "film",
  icon: "Film"
}, {
  stem: "filter-1",
  icon: "Filter1"
}, {
  stem: "filter-2",
  icon: "Filter2"
}, {
  stem: "filter-3",
  icon: "Filter3"
}, {
  stem: "filter-clear",
  icon: "FilterClear"
}, {
  stem: "filter-off",
  icon: "FilterOff"
}, {
  stem: "filter",
  icon: "Filter"
}, {
  stem: "fingerprint-1",
  icon: "Fingerprint1"
}, {
  stem: "fingerprint-2",
  icon: "Fingerprint2"
}, {
  stem: "fingerprint-3",
  icon: "Fingerprint3"
}, {
  stem: "fingerprint",
  icon: "Fingerprint"
}, {
  stem: "fish",
  icon: "Fish"
}, {
  stem: "flag-1",
  icon: "Flag1"
}, {
  stem: "flag-2",
  icon: "Flag2"
}, {
  stem: "flag-3",
  icon: "Flag3"
}, {
  stem: "flag-4",
  icon: "Flag4"
}, {
  stem: "flag",
  icon: "Flag"
}, {
  stem: "flashlight",
  icon: "Flashlight"
}, {
  stem: "flight-landing",
  icon: "FlightLanding"
}, {
  stem: "flight-takeoff",
  icon: "FlightTakeoff"
}, {
  stem: "flip-smiling-face",
  icon: "FlipSmilingFace"
}, {
  stem: "flip-to-back",
  icon: "FlipToBack"
}, {
  stem: "flip-to-front",
  icon: "FlipToFront"
}, {
  stem: "focus",
  icon: "Focus"
}, {
  stem: "fog-night",
  icon: "FogNight"
}, {
  stem: "fog-sunny",
  icon: "FogSunny"
}, {
  stem: "fog",
  icon: "Fog"
}, {
  stem: "folder-1",
  icon: "Folder1"
}, {
  stem: "folder-add-1",
  icon: "FolderAdd1"
}, {
  stem: "folder-add",
  icon: "FolderAdd"
}, {
  stem: "folder-blocked",
  icon: "FolderBlocked"
}, {
  stem: "folder-details",
  icon: "FolderDetails"
}, {
  stem: "folder-export",
  icon: "FolderExport"
}, {
  stem: "folder-import",
  icon: "FolderImport"
}, {
  stem: "folder-locked",
  icon: "FolderLocked"
}, {
  stem: "folder-minus",
  icon: "FolderMinus"
}, {
  stem: "folder-move",
  icon: "FolderMove"
}, {
  stem: "folder-off",
  icon: "FolderOff"
}, {
  stem: "folder-open-1",
  icon: "FolderOpen1"
}, {
  stem: "folder-open",
  icon: "FolderOpen"
}, {
  stem: "folder-search",
  icon: "FolderSearch"
}, {
  stem: "folder-setting",
  icon: "FolderSetting"
}, {
  stem: "folder-shared",
  icon: "FolderShared"
}, {
  stem: "folder-unlocked",
  icon: "FolderUnlocked"
}, {
  stem: "folder-zip",
  icon: "FolderZip"
}, {
  stem: "folder",
  icon: "Folder"
}, {
  stem: "forest",
  icon: "Forest"
}, {
  stem: "fork",
  icon: "Fork"
}, {
  stem: "form",
  icon: "Form"
}, {
  stem: "format-horizontal-align-bottom",
  icon: "FormatHorizontalAlignBottom"
}, {
  stem: "format-horizontal-align-center",
  icon: "FormatHorizontalAlignCenter"
}, {
  stem: "format-horizontal-align-top",
  icon: "FormatHorizontalAlignTop"
}, {
  stem: "format-vertical-align-center",
  icon: "FormatVerticalAlignCenter"
}, {
  stem: "format-vertical-align-left",
  icon: "FormatVerticalAlignLeft"
}, {
  stem: "format-vertical-align-right",
  icon: "FormatVerticalAlignRight"
}, {
  stem: "forward",
  icon: "Forward"
}, {
  stem: "frame-1",
  icon: "Frame1"
}, {
  stem: "frame",
  icon: "Frame"
}, {
  stem: "fries",
  icon: "Fries"
}, {
  stem: "fullscreen-1",
  icon: "Fullscreen1"
}, {
  stem: "fullscreen-2",
  icon: "Fullscreen2"
}, {
  stem: "fullscreen-exit-1",
  icon: "FullscreenExit1"
}, {
  stem: "fullscreen-exit",
  icon: "FullscreenExit"
}, {
  stem: "fullscreen",
  icon: "Fullscreen"
}, {
  stem: "function-curve",
  icon: "FunctionCurve"
}, {
  stem: "functions-1",
  icon: "Functions1"
}, {
  stem: "functions",
  icon: "Functions"
}, {
  stem: "gamepad-1",
  icon: "Gamepad1"
}, {
  stem: "gamepad",
  icon: "Gamepad"
}, {
  stem: "gamma",
  icon: "Gamma"
}, {
  stem: "garlic",
  icon: "Garlic"
}, {
  stem: "gender-female",
  icon: "GenderFemale"
}, {
  stem: "gender-male",
  icon: "GenderMale"
}, {
  stem: "gesture-applause",
  icon: "GestureApplause"
}, {
  stem: "gesture-click",
  icon: "GestureClick"
}, {
  stem: "gesture-down",
  icon: "GestureDown"
}, {
  stem: "gesture-expansion",
  icon: "GestureExpansion"
}, {
  stem: "gesture-left-slip",
  icon: "GestureLeftSlip"
}, {
  stem: "gesture-left",
  icon: "GestureLeft"
}, {
  stem: "gesture-pray-1",
  icon: "GesturePray1"
}, {
  stem: "gesture-pray",
  icon: "GesturePray"
}, {
  stem: "gesture-press",
  icon: "GesturePress"
}, {
  stem: "gesture-ranslation-1",
  icon: "GestureRanslation1"
}, {
  stem: "gesture-ranslation",
  icon: "GestureRanslation"
}, {
  stem: "gesture-right-slip",
  icon: "GestureRightSlip"
}, {
  stem: "gesture-right",
  icon: "GestureRight"
}, {
  stem: "gesture-slide-up",
  icon: "GestureSlideUp"
}, {
  stem: "gesture-up-1",
  icon: "GestureUp1"
}, {
  stem: "gesture-up-2",
  icon: "GestureUp2"
}, {
  stem: "gesture-up-and-down",
  icon: "GestureUpAndDown"
}, {
  stem: "gesture-up",
  icon: "GestureUp"
}, {
  stem: "gesture-wipe-down",
  icon: "GestureWipeDown"
}, {
  stem: "gift",
  icon: "Gift"
}, {
  stem: "giggle",
  icon: "Giggle"
}, {
  stem: "git-branch",
  icon: "GitBranch"
}, {
  stem: "git-commit",
  icon: "GitCommit"
}, {
  stem: "git-merge",
  icon: "GitMerge"
}, {
  stem: "git-pull-request",
  icon: "GitPullRequest"
}, {
  stem: "git-repository-commits",
  icon: "GitRepositoryCommits"
}, {
  stem: "git-repository-private",
  icon: "GitRepositoryPrivate"
}, {
  stem: "git-repository",
  icon: "GitRepository"
}, {
  stem: "gps",
  icon: "Gps"
}, {
  stem: "grape",
  icon: "Grape"
}, {
  stem: "greater-than-or-equal",
  icon: "GreaterThanOrEqual"
}, {
  stem: "greater-than",
  icon: "GreaterThan"
}, {
  stem: "green-onion",
  icon: "GreenOnion"
}, {
  stem: "grid-add",
  icon: "GridAdd"
}, {
  stem: "grid-view",
  icon: "GridView"
}, {
  stem: "guitar",
  icon: "Guitar"
}, {
  stem: "hamburger",
  icon: "Hamburger"
}, {
  stem: "happy",
  icon: "Happy"
}, {
  stem: "hard-disk-storage",
  icon: "HardDiskStorage"
}, {
  stem: "hard-drive",
  icon: "HardDrive"
}, {
  stem: "hashtag",
  icon: "Hashtag"
}, {
  stem: "hd",
  icon: "Hd"
}, {
  stem: "heart-filled",
  icon: "HeartFilled"
}, {
  stem: "heart",
  icon: "Heart"
}, {
  stem: "help-circle-filled",
  icon: "HelpCircleFilled"
}, {
  stem: "help-circle",
  icon: "HelpCircle"
}, {
  stem: "help-rectangle",
  icon: "HelpRectangle"
}, {
  stem: "help",
  icon: "Help"
}, {
  stem: "highlight-1",
  icon: "Highlight1"
}, {
  stem: "highlight",
  icon: "Highlight"
}, {
  stem: "history-setting",
  icon: "HistorySetting"
}, {
  stem: "history",
  icon: "History"
}, {
  stem: "home",
  icon: "Home"
}, {
  stem: "hospital-1",
  icon: "Hospital1"
}, {
  stem: "hospital",
  icon: "Hospital"
}, {
  stem: "hotspot-wave",
  icon: "HotspotWave"
}, {
  stem: "hourglass",
  icon: "Hourglass"
}, {
  stem: "houses-1",
  icon: "Houses1"
}, {
  stem: "houses-2",
  icon: "Houses2"
}, {
  stem: "houses",
  icon: "Houses"
}, {
  stem: "html5",
  icon: "Html5"
}, {
  stem: "https",
  icon: "Https"
}, {
  stem: "ice-cream",
  icon: "IceCream"
}, {
  stem: "icon",
  icon: "Icon"
}, {
  stem: "image-1",
  icon: "Image1"
}, {
  stem: "image-add",
  icon: "ImageAdd"
}, {
  stem: "image-edit",
  icon: "ImageEdit"
}, {
  stem: "image-error",
  icon: "ImageError"
}, {
  stem: "image-off",
  icon: "ImageOff"
}, {
  stem: "image-search",
  icon: "ImageSearch"
}, {
  stem: "image",
  icon: "Image"
}, {
  stem: "indent-left",
  icon: "IndentLeft"
}, {
  stem: "indent-right",
  icon: "IndentRight"
}, {
  stem: "indicator",
  icon: "Indicator"
}, {
  stem: "info-circle-filled",
  icon: "InfoCircleFilled"
}, {
  stem: "info-circle",
  icon: "InfoCircle"
}, {
  stem: "ink",
  icon: "Ink"
}, {
  stem: "install-desktop",
  icon: "InstallDesktop"
}, {
  stem: "install-mobile",
  icon: "InstallMobile"
}, {
  stem: "install",
  icon: "Install"
}, {
  stem: "institution-checked",
  icon: "InstitutionChecked"
}, {
  stem: "institution",
  icon: "Institution"
}, {
  stem: "internet",
  icon: "Internet"
}, {
  stem: "ipod",
  icon: "Ipod"
}, {
  stem: "joyful",
  icon: "Joyful"
}, {
  stem: "jump-off",
  icon: "JumpOff"
}, {
  stem: "jump",
  icon: "Jump"
}, {
  stem: "keyboard",
  icon: "Keyboard"
}, {
  stem: "laptop",
  icon: "Laptop"
}, {
  stem: "layers",
  icon: "Layers"
}, {
  stem: "layout",
  icon: "Layout"
}, {
  stem: "leaderboard",
  icon: "Leaderboard"
}, {
  stem: "lemon-slice",
  icon: "LemonSlice"
}, {
  stem: "lemon",
  icon: "Lemon"
}, {
  stem: "less-than-or-equal",
  icon: "LessThanOrEqual"
}, {
  stem: "less-than",
  icon: "LessThan"
}, {
  stem: "letters-a",
  icon: "LettersA"
}, {
  stem: "letters-b",
  icon: "LettersB"
}, {
  stem: "letters-c",
  icon: "LettersC"
}, {
  stem: "letters-d",
  icon: "LettersD"
}, {
  stem: "letters-e",
  icon: "LettersE"
}, {
  stem: "letters-f",
  icon: "LettersF"
}, {
  stem: "letters-g",
  icon: "LettersG"
}, {
  stem: "letters-h",
  icon: "LettersH"
}, {
  stem: "letters-i",
  icon: "LettersI"
}, {
  stem: "letters-j",
  icon: "LettersJ"
}, {
  stem: "letters-k",
  icon: "LettersK"
}, {
  stem: "letters-l",
  icon: "LettersL"
}, {
  stem: "letters-m",
  icon: "LettersM"
}, {
  stem: "letters-n",
  icon: "LettersN"
}, {
  stem: "letters-o",
  icon: "LettersO"
}, {
  stem: "letters-p",
  icon: "LettersP"
}, {
  stem: "letters-q",
  icon: "LettersQ"
}, {
  stem: "letters-r",
  icon: "LettersR"
}, {
  stem: "letters-s",
  icon: "LettersS"
}, {
  stem: "letters-t",
  icon: "LettersT"
}, {
  stem: "letters-u",
  icon: "LettersU"
}, {
  stem: "letters-v",
  icon: "LettersV"
}, {
  stem: "letters-w",
  icon: "LettersW"
}, {
  stem: "letters-x",
  icon: "LettersX"
}, {
  stem: "letters-y",
  icon: "LettersY"
}, {
  stem: "letters-z",
  icon: "LettersZ"
}, {
  stem: "lightbulb-circle",
  icon: "LightbulbCircle"
}, {
  stem: "lightbulb",
  icon: "Lightbulb"
}, {
  stem: "lighthouse-1",
  icon: "Lighthouse1"
}, {
  stem: "lighthouse-2",
  icon: "Lighthouse2"
}, {
  stem: "lighthouse",
  icon: "Lighthouse"
}, {
  stem: "lighting-circle",
  icon: "LightingCircle"
}, {
  stem: "line-height",
  icon: "LineHeight"
}, {
  stem: "link-1",
  icon: "Link1"
}, {
  stem: "link-unlink",
  icon: "LinkUnlink"
}, {
  stem: "link",
  icon: "Link"
}, {
  stem: "liquor",
  icon: "Liquor"
}, {
  stem: "list",
  icon: "List"
}, {
  stem: "load",
  icon: "Load"
}, {
  stem: "loading",
  icon: "Loading"
}, {
  stem: "location-1",
  icon: "Location1"
}, {
  stem: "location-enlargement",
  icon: "LocationEnlargement"
}, {
  stem: "location-error",
  icon: "LocationError"
}, {
  stem: "location-parking-place",
  icon: "LocationParkingPlace"
}, {
  stem: "location-reduction",
  icon: "LocationReduction"
}, {
  stem: "location-setting",
  icon: "LocationSetting"
}, {
  stem: "location",
  icon: "Location"
}, {
  stem: "lock-off",
  icon: "LockOff"
}, {
  stem: "lock-on",
  icon: "LockOn"
}, {
  stem: "lock-time",
  icon: "LockTime"
}, {
  stem: "login",
  icon: "Login"
}, {
  stem: "logo-adobe-illustrate",
  icon: "LogoAdobeIllustrate"
}, {
  stem: "logo-adobe-photoshop-1",
  icon: "LogoAdobePhotoshop1"
}, {
  stem: "logo-adobe-photoshop",
  icon: "LogoAdobePhotoshop"
}, {
  stem: "logo-android",
  icon: "LogoAndroid"
}, {
  stem: "logo-apple-filled",
  icon: "LogoAppleFilled"
}, {
  stem: "logo-apple",
  icon: "LogoApple"
}, {
  stem: "logo-behance",
  icon: "LogoBehance"
}, {
  stem: "logo-chrome-filled",
  icon: "LogoChromeFilled"
}, {
  stem: "logo-chrome",
  icon: "LogoChrome"
}, {
  stem: "logo-cinema4d",
  icon: "LogoCinema4D"
}, {
  stem: "logo-codepen",
  icon: "LogoCodepen"
}, {
  stem: "logo-codesandbox",
  icon: "LogoCodesandbox"
}, {
  stem: "logo-dribbble",
  icon: "LogoDribbble"
}, {
  stem: "logo-facebook",
  icon: "LogoFacebook"
}, {
  stem: "logo-figma",
  icon: "LogoFigma"
}, {
  stem: "logo-framer",
  icon: "LogoFramer"
}, {
  stem: "logo-github-filled",
  icon: "LogoGithubFilled"
}, {
  stem: "logo-github",
  icon: "LogoGithub"
}, {
  stem: "logo-gitlab",
  icon: "LogoGitlab"
}, {
  stem: "logo-ie-filled",
  icon: "LogoIeFilled"
}, {
  stem: "logo-ie",
  icon: "LogoIe"
}, {
  stem: "logo-instagram",
  icon: "LogoInstagram"
}, {
  stem: "logo-qq",
  icon: "LogoQq"
}, {
  stem: "logo-twitter",
  icon: "LogoTwitter"
}, {
  stem: "logo-wechat-stroke",
  icon: "LogoWechatStroke"
}, {
  stem: "logo-wechat",
  icon: "LogoWechat"
}, {
  stem: "logo-wecom",
  icon: "LogoWecom"
}, {
  stem: "logo-windows-filled",
  icon: "LogoWindowsFilled"
}, {
  stem: "logo-windows",
  icon: "LogoWindows"
}, {
  stem: "logo-youtube",
  icon: "LogoYoutube"
}, {
  stem: "logout",
  icon: "Logout"
}, {
  stem: "look-around",
  icon: "LookAround"
}, {
  stem: "loudspeaker",
  icon: "Loudspeaker"
}, {
  stem: "mail",
  icon: "Mail"
}, {
  stem: "map-3d",
  icon: "Map3D"
}, {
  stem: "map-add",
  icon: "MapAdd"
}, {
  stem: "map-aiming",
  icon: "MapAiming"
}, {
  stem: "map-blocked",
  icon: "MapBlocked"
}, {
  stem: "map-bubble",
  icon: "MapBubble"
}, {
  stem: "map-cancel",
  icon: "MapCancel"
}, {
  stem: "map-chat",
  icon: "MapChat"
}, {
  stem: "map-checked",
  icon: "MapChecked"
}, {
  stem: "map-collection",
  icon: "MapCollection"
}, {
  stem: "map-connection",
  icon: "MapConnection"
}, {
  stem: "map-distance",
  icon: "MapDistance"
}, {
  stem: "map-double",
  icon: "MapDouble"
}, {
  stem: "map-edit",
  icon: "MapEdit"
}, {
  stem: "map-grid",
  icon: "MapGrid"
}, {
  stem: "map-information-1",
  icon: "MapInformation1"
}, {
  stem: "map-information-2",
  icon: "MapInformation2"
}, {
  stem: "map-information",
  icon: "MapInformation"
}, {
  stem: "map-location",
  icon: "MapLocation"
}, {
  stem: "map-locked",
  icon: "MapLocked"
}, {
  stem: "map-marked",
  icon: "MapMarked"
}, {
  stem: "map-navigation",
  icon: "MapNavigation"
}, {
  stem: "map-outline",
  icon: "MapOutline"
}, {
  stem: "map-route-planning",
  icon: "MapRoutePlanning"
}, {
  stem: "map-ruler",
  icon: "MapRuler"
}, {
  stem: "map-safety",
  icon: "MapSafety"
}, {
  stem: "map-search-1",
  icon: "MapSearch1"
}, {
  stem: "map-search",
  icon: "MapSearch"
}, {
  stem: "map-setting",
  icon: "MapSetting"
}, {
  stem: "map-unlocked",
  icon: "MapUnlocked"
}, {
  stem: "map",
  icon: "Map"
}, {
  stem: "mark-as-unread",
  icon: "MarkAsUnread"
}, {
  stem: "markup",
  icon: "Markup"
}, {
  stem: "mathematics",
  icon: "Mathematics"
}, {
  stem: "measurement-1",
  icon: "Measurement1"
}, {
  stem: "measurement-2",
  icon: "Measurement2"
}, {
  stem: "measurement",
  icon: "Measurement"
}, {
  stem: "meat-pepper",
  icon: "MeatPepper"
}, {
  stem: "media-library",
  icon: "MediaLibrary"
}, {
  stem: "member",
  icon: "Member"
}, {
  stem: "menu-application",
  icon: "MenuApplication"
}, {
  stem: "menu-fold",
  icon: "MenuFold"
}, {
  stem: "menu-unfold",
  icon: "MenuUnfold"
}, {
  stem: "menu",
  icon: "Menu"
}, {
  stem: "merge-cells",
  icon: "MergeCells"
}, {
  stem: "microphone-1",
  icon: "Microphone1"
}, {
  stem: "microphone-2",
  icon: "Microphone2"
}, {
  stem: "microphone",
  icon: "Microphone"
}, {
  stem: "milk",
  icon: "Milk"
}, {
  stem: "minus-circle-filled",
  icon: "MinusCircleFilled"
}, {
  stem: "minus-circle",
  icon: "MinusCircle"
}, {
  stem: "minus-rectangle-filled",
  icon: "MinusRectangleFilled"
}, {
  stem: "minus-rectangle",
  icon: "MinusRectangle"
}, {
  stem: "minus",
  icon: "Minus"
}, {
  stem: "mirror",
  icon: "Mirror"
}, {
  stem: "mobile-blocked",
  icon: "MobileBlocked"
}, {
  stem: "mobile-list",
  icon: "MobileList"
}, {
  stem: "mobile-navigation",
  icon: "MobileNavigation"
}, {
  stem: "mobile-shortcut",
  icon: "MobileShortcut"
}, {
  stem: "mobile-vibrate",
  icon: "MobileVibrate"
}, {
  stem: "mobile",
  icon: "Mobile"
}, {
  stem: "mode-dark",
  icon: "ModeDark"
}, {
  stem: "mode-light",
  icon: "ModeLight"
}, {
  stem: "module",
  icon: "Module"
}, {
  stem: "money",
  icon: "Money"
}, {
  stem: "monument",
  icon: "Monument"
}, {
  stem: "moon-fall",
  icon: "MoonFall"
}, {
  stem: "moon-rising",
  icon: "MoonRising"
}, {
  stem: "moon",
  icon: "Moon"
}, {
  stem: "more",
  icon: "More"
}, {
  stem: "mosque-1",
  icon: "Mosque1"
}, {
  stem: "mosque",
  icon: "Mosque"
}, {
  stem: "mouse",
  icon: "Mouse"
}, {
  stem: "move-1",
  icon: "Move1"
}, {
  stem: "move",
  icon: "Move"
}, {
  stem: "movie-clapper",
  icon: "MovieClapper"
}, {
  stem: "multiply",
  icon: "Multiply"
}, {
  stem: "museum-1",
  icon: "Museum1"
}, {
  stem: "museum-2",
  icon: "Museum2"
}, {
  stem: "museum",
  icon: "Museum"
}, {
  stem: "mushroom-1",
  icon: "Mushroom1"
}, {
  stem: "mushroom",
  icon: "Mushroom"
}, {
  stem: "music-1",
  icon: "Music1"
}, {
  stem: "music-2",
  icon: "Music2"
}, {
  stem: "music-rectangle-add",
  icon: "MusicRectangleAdd"
}, {
  stem: "music",
  icon: "Music"
}, {
  stem: "navigation-arrow",
  icon: "NavigationArrow"
}, {
  stem: "next",
  icon: "Next"
}, {
  stem: "no-expression",
  icon: "NoExpression"
}, {
  stem: "noodle",
  icon: "Noodle"
}, {
  stem: "notification-add",
  icon: "NotificationAdd"
}, {
  stem: "notification-circle",
  icon: "NotificationCircle"
}, {
  stem: "notification-error",
  icon: "NotificationError"
}, {
  stem: "notification-filled",
  icon: "NotificationFilled"
}, {
  stem: "notification",
  icon: "Notification"
}, {
  stem: "numbers-0-1",
  icon: "Numbers01"
}, {
  stem: "numbers-0",
  icon: "Numbers0"
}, {
  stem: "numbers-1-1",
  icon: "Numbers11"
}, {
  stem: "numbers-1",
  icon: "Numbers1"
}, {
  stem: "numbers-2-1",
  icon: "Numbers21"
}, {
  stem: "numbers-2",
  icon: "Numbers2"
}, {
  stem: "numbers-3-1",
  icon: "Numbers31"
}, {
  stem: "numbers-3",
  icon: "Numbers3"
}, {
  stem: "numbers-4-1",
  icon: "Numbers41"
}, {
  stem: "numbers-4",
  icon: "Numbers4"
}, {
  stem: "numbers-5-1",
  icon: "Numbers51"
}, {
  stem: "numbers-5",
  icon: "Numbers5"
}, {
  stem: "numbers-6-1",
  icon: "Numbers61"
}, {
  stem: "numbers-6",
  icon: "Numbers6"
}, {
  stem: "numbers-7-1",
  icon: "Numbers71"
}, {
  stem: "numbers-7",
  icon: "Numbers7"
}, {
  stem: "numbers-8-1",
  icon: "Numbers81"
}, {
  stem: "numbers-8",
  icon: "Numbers8"
}, {
  stem: "numbers-9-1",
  icon: "Numbers91"
}, {
  stem: "numbers-9",
  icon: "Numbers9"
}, {
  stem: "nut",
  icon: "Nut"
}, {
  stem: "object-storage",
  icon: "ObjectStorage"
}, {
  stem: "open-mouth",
  icon: "OpenMouth"
}, {
  stem: "opera",
  icon: "Opera"
}, {
  stem: "order-adjustment-column",
  icon: "OrderAdjustmentColumn"
}, {
  stem: "order-ascending",
  icon: "OrderAscending"
}, {
  stem: "order-descending",
  icon: "OrderDescending"
}, {
  stem: "outbox",
  icon: "Outbox"
}, {
  stem: "page-first",
  icon: "PageFirst"
}, {
  stem: "page-head",
  icon: "PageHead"
}, {
  stem: "page-last",
  icon: "PageLast"
}, {
  stem: "palace-1",
  icon: "Palace1"
}, {
  stem: "palace-2",
  icon: "Palace2"
}, {
  stem: "palace-3",
  icon: "Palace3"
}, {
  stem: "palace-4",
  icon: "Palace4"
}, {
  stem: "palace",
  icon: "Palace"
}, {
  stem: "palette-1",
  icon: "Palette1"
}, {
  stem: "palette",
  icon: "Palette"
}, {
  stem: "panorama-horizontal",
  icon: "PanoramaHorizontal"
}, {
  stem: "panorama-vertical",
  icon: "PanoramaVertical"
}, {
  stem: "pantone",
  icon: "Pantone"
}, {
  stem: "parabola",
  icon: "Parabola"
}, {
  stem: "parentheses",
  icon: "Parentheses"
}, {
  stem: "paste",
  icon: "Paste"
}, {
  stem: "patio",
  icon: "Patio"
}, {
  stem: "pause-circle-filled",
  icon: "PauseCircleFilled"
}, {
  stem: "pause-circle-stroke",
  icon: "PauseCircleStroke"
}, {
  stem: "pause-circle",
  icon: "PauseCircle"
}, {
  stem: "pause",
  icon: "Pause"
}, {
  stem: "pea",
  icon: "Pea"
}, {
  stem: "peach",
  icon: "Peach"
}, {
  stem: "pear",
  icon: "Pear"
}, {
  stem: "pearl-of-the-orient",
  icon: "PearlOfTheOrient"
}, {
  stem: "pen-ball",
  icon: "PenBall"
}, {
  stem: "pen-brush",
  icon: "PenBrush"
}, {
  stem: "pen-mark",
  icon: "PenMark"
}, {
  stem: "pen-quill",
  icon: "PenQuill"
}, {
  stem: "pen",
  icon: "Pen"
}, {
  stem: "pending",
  icon: "Pending"
}, {
  stem: "percent",
  icon: "Percent"
}, {
  stem: "personal-information",
  icon: "PersonalInformation"
}, {
  stem: "phone-locked",
  icon: "PhoneLocked"
}, {
  stem: "phone-search",
  icon: "PhoneSearch"
}, {
  stem: "pi",
  icon: "Pi"
}, {
  stem: "piano",
  icon: "Piano"
}, {
  stem: "pin-filled",
  icon: "PinFilled"
}, {
  stem: "pin",
  icon: "Pin"
}, {
  stem: "play-circle-filled",
  icon: "PlayCircleFilled"
}, {
  stem: "play-circle-stroke-add",
  icon: "PlayCircleStrokeAdd"
}, {
  stem: "play-circle-stroke",
  icon: "PlayCircleStroke"
}, {
  stem: "play-circle",
  icon: "PlayCircle"
}, {
  stem: "play-demo",
  icon: "PlayDemo"
}, {
  stem: "play-rectangle",
  icon: "PlayRectangle"
}, {
  stem: "play",
  icon: "Play"
}, {
  stem: "plus",
  icon: "Plus"
}, {
  stem: "popsicle",
  icon: "Popsicle"
}, {
  stem: "portrait",
  icon: "Portrait"
}, {
  stem: "pout",
  icon: "Pout"
}, {
  stem: "poweroff",
  icon: "Poweroff"
}, {
  stem: "precise-monitor",
  icon: "PreciseMonitor"
}, {
  stem: "previous",
  icon: "Previous"
}, {
  stem: "print",
  icon: "Print"
}, {
  stem: "pumpkin",
  icon: "Pumpkin"
}, {
  stem: "pyramid-maya",
  icon: "PyramidMaya"
}, {
  stem: "pyramid",
  icon: "Pyramid"
}, {
  stem: "qrcode",
  icon: "Qrcode"
}, {
  stem: "quadratic",
  icon: "Quadratic"
}, {
  stem: "questionnaire",
  icon: "Questionnaire"
}, {
  stem: "queue",
  icon: "Queue"
}, {
  stem: "radar",
  icon: "Radar"
}, {
  stem: "radio-1",
  icon: "Radio1"
}, {
  stem: "radio-2",
  icon: "Radio2"
}, {
  stem: "radish",
  icon: "Radish"
}, {
  stem: "rain-heavy",
  icon: "RainHeavy"
}, {
  stem: "rain-light",
  icon: "RainLight"
}, {
  stem: "rain-medium",
  icon: "RainMedium"
}, {
  stem: "rainbow",
  icon: "Rainbow"
}, {
  stem: "rectangle",
  icon: "Rectangle"
}, {
  stem: "refresh",
  icon: "Refresh"
}, {
  stem: "relation",
  icon: "Relation"
}, {
  stem: "relativity",
  icon: "Relativity"
}, {
  stem: "remote-wave",
  icon: "RemoteWave"
}, {
  stem: "remove",
  icon: "Remove"
}, {
  stem: "replay",
  icon: "Replay"
}, {
  stem: "rice-ball",
  icon: "RiceBall"
}, {
  stem: "rice",
  icon: "Rice"
}, {
  stem: "roast",
  icon: "Roast"
}, {
  stem: "rocket",
  icon: "Rocket"
}, {
  stem: "rollback",
  icon: "Rollback"
}, {
  stem: "rollfront",
  icon: "Rollfront"
}, {
  stem: "root-list",
  icon: "RootList"
}, {
  stem: "rotate-locked",
  icon: "RotateLocked"
}, {
  stem: "rotate",
  icon: "Rotate"
}, {
  stem: "rotation",
  icon: "Rotation"
}, {
  stem: "round",
  icon: "Round"
}, {
  stem: "router-wave",
  icon: "RouterWave"
}, {
  stem: "rss",
  icon: "Rss"
}, {
  stem: "ruler",
  icon: "Ruler"
}, {
  stem: "sailing-hotel",
  icon: "SailingHotel"
}, {
  stem: "sandwich",
  icon: "Sandwich"
}, {
  stem: "saturation",
  icon: "Saturation"
}, {
  stem: "sausage",
  icon: "Sausage"
}, {
  stem: "save",
  icon: "Save"
}, {
  stem: "saving-pot",
  icon: "SavingPot"
}, {
  stem: "scan",
  icon: "Scan"
}, {
  stem: "screen-4k",
  icon: "Screen4K"
}, {
  stem: "screencast",
  icon: "Screencast"
}, {
  stem: "screenshot",
  icon: "Screenshot"
}, {
  stem: "scroll-bar",
  icon: "ScrollBar"
}, {
  stem: "sd-card-1",
  icon: "SdCard1"
}, {
  stem: "sd-card",
  icon: "SdCard"
}, {
  stem: "search-error",
  icon: "SearchError"
}, {
  stem: "search",
  icon: "Search"
}, {
  stem: "secured",
  icon: "Secured"
}, {
  stem: "send-cancel",
  icon: "SendCancel"
}, {
  stem: "send",
  icon: "Send"
}, {
  stem: "sensors-1",
  icon: "Sensors1"
}, {
  stem: "sensors-2",
  icon: "Sensors2"
}, {
  stem: "sensors-off",
  icon: "SensorsOff"
}, {
  stem: "sensors",
  icon: "Sensors"
}, {
  stem: "serenity",
  icon: "Serenity"
}, {
  stem: "server",
  icon: "Server"
}, {
  stem: "service",
  icon: "Service"
}, {
  stem: "setting-1",
  icon: "Setting1"
}, {
  stem: "setting",
  icon: "Setting"
}, {
  stem: "share-1",
  icon: "Share1"
}, {
  stem: "share",
  icon: "Share"
}, {
  stem: "sharpness",
  icon: "Sharpness"
}, {
  stem: "shield-error",
  icon: "ShieldError"
}, {
  stem: "shimen",
  icon: "Shimen"
}, {
  stem: "shop-1",
  icon: "Shop1"
}, {
  stem: "shop-2",
  icon: "Shop2"
}, {
  stem: "shop-3",
  icon: "Shop3"
}, {
  stem: "shop-4",
  icon: "Shop4"
}, {
  stem: "shop-5",
  icon: "Shop5"
}, {
  stem: "shop",
  icon: "Shop"
}, {
  stem: "shrimp",
  icon: "Shrimp"
}, {
  stem: "shrink-horizontal",
  icon: "ShrinkHorizontal"
}, {
  stem: "shrink-vertical",
  icon: "ShrinkVertical"
}, {
  stem: "shutter",
  icon: "Shutter"
}, {
  stem: "shutup",
  icon: "Shutup"
}, {
  stem: "sim-card-1",
  icon: "SimCard1"
}, {
  stem: "sim-card-2",
  icon: "SimCard2"
}, {
  stem: "sim-card",
  icon: "SimCard"
}, {
  stem: "sinister-smile",
  icon: "SinisterSmile"
}, {
  stem: "sip",
  icon: "Sip"
}, {
  stem: "slash",
  icon: "Slash"
}, {
  stem: "sleep",
  icon: "Sleep"
}, {
  stem: "slice",
  icon: "Slice"
}, {
  stem: "slideshow",
  icon: "Slideshow"
}, {
  stem: "smile",
  icon: "Smile"
}, {
  stem: "sneer",
  icon: "Sneer"
}, {
  stem: "snowflake",
  icon: "Snowflake"
}, {
  stem: "sonic",
  icon: "Sonic"
}, {
  stem: "sound-down",
  icon: "SoundDown"
}, {
  stem: "sound-high",
  icon: "SoundHigh"
}, {
  stem: "sound-low",
  icon: "SoundLow"
}, {
  stem: "sound-mute-1",
  icon: "SoundMute1"
}, {
  stem: "sound-mute",
  icon: "SoundMute"
}, {
  stem: "sound-up",
  icon: "SoundUp"
}, {
  stem: "sound",
  icon: "Sound"
}, {
  stem: "space",
  icon: "Space"
}, {
  stem: "speechless-1",
  icon: "Speechless1"
}, {
  stem: "star-filled",
  icon: "StarFilled"
}, {
  stem: "star",
  icon: "Star"
}, {
  stem: "statue-of-jesus",
  icon: "StatueOfJesus"
}, {
  stem: "sticky-note",
  icon: "StickyNote"
}, {
  stem: "stop-circle-filled",
  icon: "StopCircleFilled"
}, {
  stem: "stop-circle-stroke",
  icon: "StopCircleStroke"
}, {
  stem: "stop-circle",
  icon: "StopCircle"
}, {
  stem: "stop",
  icon: "Stop"
}, {
  stem: "store",
  icon: "Store"
}, {
  stem: "street-road-1",
  icon: "StreetRoad1"
}, {
  stem: "street-road",
  icon: "StreetRoad"
}, {
  stem: "subtitle",
  icon: "Subtitle"
}, {
  stem: "subway-line",
  icon: "SubwayLine"
}, {
  stem: "sum",
  icon: "Sum"
}, {
  stem: "sun-fall",
  icon: "SunFall"
}, {
  stem: "sun-rising",
  icon: "SunRising"
}, {
  stem: "sunny",
  icon: "Sunny"
}, {
  stem: "support",
  icon: "Support"
}, {
  stem: "surprised-1",
  icon: "Surprised1"
}, {
  stem: "surprised",
  icon: "Surprised"
}, {
  stem: "swap-left",
  icon: "SwapLeft"
}, {
  stem: "swap-right",
  icon: "SwapRight"
}, {
  stem: "swap",
  icon: "Swap"
}, {
  stem: "swear-1",
  icon: "Swear1"
}, {
  stem: "swear-2",
  icon: "Swear2"
}, {
  stem: "system-2",
  icon: "System2"
}, {
  stem: "system-3",
  icon: "System3"
}, {
  stem: "system-application",
  icon: "SystemApplication"
}, {
  stem: "system-blocked",
  icon: "SystemBlocked"
}, {
  stem: "system-code",
  icon: "SystemCode"
}, {
  stem: "system-components",
  icon: "SystemComponents"
}, {
  stem: "system-coordinate",
  icon: "SystemCoordinate"
}, {
  stem: "system-device",
  icon: "SystemDevice"
}, {
  stem: "system-interface",
  icon: "SystemInterface"
}, {
  stem: "system-location",
  icon: "SystemLocation"
}, {
  stem: "system-locked",
  icon: "SystemLocked"
}, {
  stem: "system-log",
  icon: "SystemLog"
}, {
  stem: "system-marked",
  icon: "SystemMarked"
}, {
  stem: "system-messages",
  icon: "SystemMessages"
}, {
  stem: "system-regulation",
  icon: "SystemRegulation"
}, {
  stem: "system-search",
  icon: "SystemSearch"
}, {
  stem: "system-setting",
  icon: "SystemSetting"
}, {
  stem: "system-storage",
  icon: "SystemStorage"
}, {
  stem: "system-sum",
  icon: "SystemSum"
}, {
  stem: "system-unlocked",
  icon: "SystemUnlocked"
}, {
  stem: "tab",
  icon: "Tab"
}, {
  stem: "table-1",
  icon: "Table1"
}, {
  stem: "table-2",
  icon: "Table2"
}, {
  stem: "table-add",
  icon: "TableAdd"
}, {
  stem: "table-split",
  icon: "TableSplit"
}, {
  stem: "table",
  icon: "Table"
}, {
  stem: "tag",
  icon: "Tag"
}, {
  stem: "tangerinr",
  icon: "Tangerinr"
}, {
  stem: "tape",
  icon: "Tape"
}, {
  stem: "task-1",
  icon: "Task1"
}, {
  stem: "task-add-1",
  icon: "TaskAdd1"
}, {
  stem: "task-add",
  icon: "TaskAdd"
}, {
  stem: "task-checked",
  icon: "TaskChecked"
}, {
  stem: "task-error",
  icon: "TaskError"
}, {
  stem: "task-location",
  icon: "TaskLocation"
}, {
  stem: "task-marked",
  icon: "TaskMarked"
}, {
  stem: "task-setting",
  icon: "TaskSetting"
}, {
  stem: "task-visible",
  icon: "TaskVisible"
}, {
  stem: "task",
  icon: "Task"
}, {
  stem: "tea",
  icon: "Tea"
}, {
  stem: "teahouse",
  icon: "Teahouse"
}, {
  stem: "template",
  icon: "Template"
}, {
  stem: "temple",
  icon: "Temple"
}, {
  stem: "terminal-rectangle-1",
  icon: "TerminalRectangle1"
}, {
  stem: "terminal-rectangle",
  icon: "TerminalRectangle"
}, {
  stem: "terminal-window",
  icon: "TerminalWindow"
}, {
  stem: "terminal",
  icon: "Terminal"
}, {
  stem: "textbox",
  icon: "Textbox"
}, {
  stem: "textformat-bold",
  icon: "TextformatBold"
}, {
  stem: "textformat-color",
  icon: "TextformatColor"
}, {
  stem: "textformat-italic",
  icon: "TextformatItalic"
}, {
  stem: "textformat-strikethrough",
  icon: "TextformatStrikethrough"
}, {
  stem: "textformat-underline",
  icon: "TextformatUnderline"
}, {
  stem: "textformat-wrap",
  icon: "TextformatWrap"
}, {
  stem: "theaters",
  icon: "Theaters"
}, {
  stem: "thumb-down-1",
  icon: "ThumbDown1"
}, {
  stem: "thumb-down-2",
  icon: "ThumbDown2"
}, {
  stem: "thumb-down",
  icon: "ThumbDown"
}, {
  stem: "thumb-up-1",
  icon: "ThumbUp1"
}, {
  stem: "thumb-up-2",
  icon: "ThumbUp2"
}, {
  stem: "thumb-up",
  icon: "ThumbUp"
}, {
  stem: "thunder",
  icon: "Thunder"
}, {
  stem: "thunderstorm-night",
  icon: "ThunderstormNight"
}, {
  stem: "thunderstorm-sunny",
  icon: "ThunderstormSunny"
}, {
  stem: "thunderstorm",
  icon: "Thunderstorm"
}, {
  stem: "ticket",
  icon: "Ticket"
}, {
  stem: "time-filled",
  icon: "TimeFilled"
}, {
  stem: "time",
  icon: "Time"
}, {
  stem: "tips-double",
  icon: "TipsDouble"
}, {
  stem: "tips",
  icon: "Tips"
}, {
  stem: "tomato",
  icon: "Tomato"
}, {
  stem: "tools-circle",
  icon: "ToolsCircle"
}, {
  stem: "tools",
  icon: "Tools"
}, {
  stem: "tornado",
  icon: "Tornado"
}, {
  stem: "tower-1",
  icon: "Tower1"
}, {
  stem: "tower-2",
  icon: "Tower2"
}, {
  stem: "tower-3",
  icon: "Tower3"
}, {
  stem: "tower-clock",
  icon: "TowerClock"
}, {
  stem: "tower",
  icon: "Tower"
}, {
  stem: "town",
  icon: "Town"
}, {
  stem: "traffic-events",
  icon: "TrafficEvents"
}, {
  stem: "traffic",
  icon: "Traffic"
}, {
  stem: "transform-1",
  icon: "Transform1"
}, {
  stem: "transform-2",
  icon: "Transform2"
}, {
  stem: "transform-3",
  icon: "Transform3"
}, {
  stem: "transform",
  icon: "Transform"
}, {
  stem: "translate-1",
  icon: "Translate1"
}, {
  stem: "translate",
  icon: "Translate"
}, {
  stem: "tree-list",
  icon: "TreeList"
}, {
  stem: "tree-round-dot-vertical",
  icon: "TreeRoundDotVertical"
}, {
  stem: "tree-round-dot",
  icon: "TreeRoundDot"
}, {
  stem: "tree-square-dot-vertical",
  icon: "TreeSquareDotVertical"
}, {
  stem: "tree-square-dot",
  icon: "TreeSquareDot"
}, {
  stem: "trending-down",
  icon: "TrendingDown"
}, {
  stem: "trending-up",
  icon: "TrendingUp"
}, {
  stem: "tv-1",
  icon: "Tv1"
}, {
  stem: "tv-2",
  icon: "Tv2"
}, {
  stem: "tv",
  icon: "Tv"
}, {
  stem: "typography",
  icon: "Typography"
}, {
  stem: "uncomfortable-1",
  icon: "Uncomfortable1"
}, {
  stem: "uncomfortable-2",
  icon: "Uncomfortable2"
}, {
  stem: "uncomfortable",
  icon: "Uncomfortable"
}, {
  stem: "undertake-delivery",
  icon: "UndertakeDelivery"
}, {
  stem: "undertake-environment-protection",
  icon: "UndertakeEnvironmentProtection"
}, {
  stem: "undertake-hold-up",
  icon: "UndertakeHoldUp"
}, {
  stem: "undertake-transaction",
  icon: "UndertakeTransaction"
}, {
  stem: "undertake",
  icon: "Undertake"
}, {
  stem: "unfold-less",
  icon: "UnfoldLess"
}, {
  stem: "unfold-more",
  icon: "UnfoldMore"
}, {
  stem: "unhappy-1",
  icon: "Unhappy1"
}, {
  stem: "unhappy",
  icon: "Unhappy"
}, {
  stem: "uninstall",
  icon: "Uninstall"
}, {
  stem: "upload-1",
  icon: "Upload1"
}, {
  stem: "upload",
  icon: "Upload"
}, {
  stem: "upscale",
  icon: "Upscale"
}, {
  stem: "usb",
  icon: "Usb"
}, {
  stem: "user-1",
  icon: "User1"
}, {
  stem: "user-add",
  icon: "UserAdd"
}, {
  stem: "user-arrow-down",
  icon: "UserArrowDown"
}, {
  stem: "user-arrow-left",
  icon: "UserArrowLeft"
}, {
  stem: "user-arrow-right",
  icon: "UserArrowRight"
}, {
  stem: "user-arrow-up",
  icon: "UserArrowUp"
}, {
  stem: "user-avatar",
  icon: "UserAvatar"
}, {
  stem: "user-blocked",
  icon: "UserBlocked"
}, {
  stem: "user-business",
  icon: "UserBusiness"
}, {
  stem: "user-checked-1",
  icon: "UserChecked1"
}, {
  stem: "user-checked",
  icon: "UserChecked"
}, {
  stem: "user-circle",
  icon: "UserCircle"
}, {
  stem: "user-clear",
  icon: "UserClear"
}, {
  stem: "user-error-1",
  icon: "UserError1"
}, {
  stem: "user-invisible",
  icon: "UserInvisible"
}, {
  stem: "user-list",
  icon: "UserList"
}, {
  stem: "user-locked",
  icon: "UserLocked"
}, {
  stem: "user-marked",
  icon: "UserMarked"
}, {
  stem: "user-password",
  icon: "UserPassword"
}, {
  stem: "user-safety",
  icon: "UserSafety"
}, {
  stem: "user-search",
  icon: "UserSearch"
}, {
  stem: "user-setting",
  icon: "UserSetting"
}, {
  stem: "user-talk-1",
  icon: "UserTalk1"
}, {
  stem: "user-talk-off-1",
  icon: "UserTalkOff1"
}, {
  stem: "user-talk",
  icon: "UserTalk"
}, {
  stem: "user-time",
  icon: "UserTime"
}, {
  stem: "user-transmit",
  icon: "UserTransmit"
}, {
  stem: "user-unknown",
  icon: "UserUnknown"
}, {
  stem: "user-unlocked",
  icon: "UserUnlocked"
}, {
  stem: "user-vip",
  icon: "UserVip"
}, {
  stem: "user-visible",
  icon: "UserVisible"
}, {
  stem: "user",
  icon: "User"
}, {
  stem: "usergroup-add",
  icon: "UsergroupAdd"
}, {
  stem: "usergroup-clear",
  icon: "UsergroupClear"
}, {
  stem: "usergroup",
  icon: "Usergroup"
}, {
  stem: "vehicle",
  icon: "Vehicle"
}, {
  stem: "verified",
  icon: "Verified"
}, {
  stem: "verify",
  icon: "Verify"
}, {
  stem: "video-camera-1",
  icon: "VideoCamera1"
}, {
  stem: "video-camera-2",
  icon: "VideoCamera2"
}, {
  stem: "video-camera-dollar",
  icon: "VideoCameraDollar"
}, {
  stem: "video-camera-minus",
  icon: "VideoCameraMinus"
}, {
  stem: "video-camera-music",
  icon: "VideoCameraMusic"
}, {
  stem: "video-camera-off",
  icon: "VideoCameraOff"
}, {
  stem: "video-camera",
  icon: "VideoCamera"
}, {
  stem: "video-library",
  icon: "VideoLibrary"
}, {
  stem: "video",
  icon: "Video"
}, {
  stem: "view-agenda",
  icon: "ViewAgenda"
}, {
  stem: "view-column",
  icon: "ViewColumn"
}, {
  stem: "view-in-ar",
  icon: "ViewInAr"
}, {
  stem: "view-list",
  icon: "ViewList"
}, {
  stem: "view-module",
  icon: "ViewModule"
}, {
  stem: "visual-recognition",
  icon: "VisualRecognition"
}, {
  stem: "wallet",
  icon: "Wallet"
}, {
  stem: "watch",
  icon: "Watch"
}, {
  stem: "watermelon",
  icon: "Watermelon"
}, {
  stem: "wave-left",
  icon: "WaveLeft"
}, {
  stem: "wave-right",
  icon: "WaveRight"
}, {
  stem: "wealth-1",
  icon: "Wealth1"
}, {
  stem: "wealth",
  icon: "Wealth"
}, {
  stem: "widget",
  icon: "Widget"
}, {
  stem: "wifi-1",
  icon: "Wifi1"
}, {
  stem: "wifi-off-1",
  icon: "WifiOff1"
}, {
  stem: "wifi-off",
  icon: "WifiOff"
}, {
  stem: "wifi",
  icon: "Wifi"
}, {
  stem: "window-1",
  icon: "Window1"
}, {
  stem: "window",
  icon: "Window"
}, {
  stem: "windy-rain",
  icon: "WindyRain"
}, {
  stem: "windy",
  icon: "Windy"
}, {
  stem: "wink",
  icon: "Wink"
}, {
  stem: "work-history",
  icon: "WorkHistory"
}, {
  stem: "work-off",
  icon: "WorkOff"
}, {
  stem: "work",
  icon: "Work"
}, {
  stem: "wry-smile",
  icon: "WrySmile"
}, {
  stem: "zoom-in",
  icon: "ZoomIn"
}, {
  stem: "zoom-out",
  icon: "ZoomOut"
}];

export { manifest };
//# sourceMappingURL=manifest.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-icons-vue/esm/manifest.js
// module id = null
// module chunks = 